import { createDataStore } from "../lib/data_store";

const accountErrorStore = createDataStore<boolean>(false);

export const useAccountError = accountErrorStore.useData as () => boolean;
export const setAccountError = accountErrorStore.setData;
